"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoMimetype = exports.VideoSourceProtocol = exports.DrmSystemToDrmKey = exports.VideoSourceDrmKey = void 0;
var VideoSourceDrmKey;
(function (VideoSourceDrmKey) {
    VideoSourceDrmKey["FAIRPLAY"] = "fairplay";
    VideoSourceDrmKey["WIDEVINE"] = "widevine";
    VideoSourceDrmKey["PLAYREADY"] = "playready";
    VideoSourceDrmKey["PRIMETIME"] = "primetime";
})(VideoSourceDrmKey = exports.VideoSourceDrmKey || (exports.VideoSourceDrmKey = {}));
exports.DrmSystemToDrmKey = {
    'com.widevine.alpha': "widevine" /* VideoSourceDrmKey.WIDEVINE */,
    'com.youtube.playready': "playready" /* VideoSourceDrmKey.PLAYREADY */,
    'com.microsoft.playready': "playready" /* VideoSourceDrmKey.PLAYREADY */,
    'com.adobe.primetime': "primetime" /* VideoSourceDrmKey.PRIMETIME */,
    'com.adobe.access': "primetime" /* VideoSourceDrmKey.PRIMETIME */,
    'com.apple.fairplay': "fairplay" /* VideoSourceDrmKey.FAIRPLAY */,
    // Modern EME from Apple is still buggy in Shaka, migrate when it's fixed
    // 'com.apple.fps': VideoSourceDrmKey.FAIRPLAY,
    'com.apple.fps.1_0': "fairplay" /* VideoSourceDrmKey.FAIRPLAY */,
    'com.apple.fps.2_0': "fairplay" /* VideoSourceDrmKey.FAIRPLAY */,
    'com.apple.fps.3_0': "fairplay" /* VideoSourceDrmKey.FAIRPLAY */,
};
var VideoSourceProtocol;
(function (VideoSourceProtocol) {
    VideoSourceProtocol["DASH"] = "dash";
    VideoSourceProtocol["HLS"] = "hls";
    VideoSourceProtocol["HSS"] = "hss";
    VideoSourceProtocol["PROGRESSIVE"] = "progressive";
})(VideoSourceProtocol = exports.VideoSourceProtocol || (exports.VideoSourceProtocol = {}));
var VideoMimetype;
(function (VideoMimetype) {
    VideoMimetype["MP4"] = "video/mp4";
    VideoMimetype["HLS"] = "application/x-mpegURL";
    VideoMimetype["WEBM"] = "video/webm";
    VideoMimetype["DASH"] = "application/dash+xml";
    VideoMimetype["HSS"] = "application/vnd.ms-sstr+xml";
})(VideoMimetype = exports.VideoMimetype || (exports.VideoMimetype = {}));
//# sourceMappingURL=video-source.js.map